import React from 'react';
import ConflictMap from '../components/ConflictMap'; // ✅ Correction de la faute de frappe

const Observatoire = () => {
  return (
    <main>
      <ConflictMap />
    </main>
  );
};

export default Observatoire;